import { useEffect, useState } from "react";
import {
  FACET_AUTOGENERATE_LOADING_STEP_INTERVAL_MS,
  FACET_AUTOGENERATE_LOADING_STEPS,
} from "../../tars-constants";

export function useFacetAutogenerateLoadingStep(active: boolean): string {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    if (!active) {
      setStepIndex(0);
      return;
    }
    const interval = window.setInterval(() => {
      setStepIndex((index) => (index + 1) % FACET_AUTOGENERATE_LOADING_STEPS.length);
    }, FACET_AUTOGENERATE_LOADING_STEP_INTERVAL_MS);
    return () => window.clearInterval(interval);
  }, [active]);

  return FACET_AUTOGENERATE_LOADING_STEPS[stepIndex];
}
